export default {"src":"/_next/static/media/Default.2c7fbd72.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};